import { observer } from 'mobx-react-lite';
import { Header, Loader, Select } from 'semantic-ui-react';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';
import { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import agent from '../../app/api/agent';
import { PcProcessCsvReport } from './types';
import UnauthorizedMessage from '../UnauthorizedMessage';

function PCProcessCsvReport() {
  const { RolesAndPermissionsIDStore, commonStore } = useStore();
  const [groupData, setGroupedData] = useState<PcProcessCsvReport[]>([]);
  const [CsvReport, setCsvReport] = useState('');
  const [loading, setLoading] = useState(false);
  const options = [
    {
      key: 'A Category Process',
      text: 'A Category Process',
      value: 'A Category Process',
    },
  ];

  useEffect(() => {
    if (!CsvReport) return;
    const HandlePcprocessACategory = async () => {
      setLoading(true);
      await agent.PCProcessCsvReport.pcprocessACategory()
        .then((Reponse) => {
          setGroupedData(Reponse.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    };
    HandlePcprocessACategory();
  }, [CsvReport]);
  return (
    <>
      {!RolesAndPermissionsIDStore.loadingInitial &&
        !commonStore.filterModeOne?.includes('PCPCSV02') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('PCPCSV02') && (
        <div className="title_wise_cutlistreport">
          <Header style={{ marginRight: '10px' }}>
            <h2>PC Process CsvReport</h2>
          </Header>
          <div style={{ display: 'flex' }}>
            <Select
              style={{ marginRight: '10px' }}
              placeholder="Select Title"
              filter
              Selection
              search
              clearable
              options={options}
              onChange={(e: any, data: any) => setCsvReport(data.value)}
            />
            {loading ? (
              <Loader active inline style={{ marginTop: '8px' }} size="small" />
            ) : CsvReport ? (
              <DynamicTableCSVReport
                tableName="Pc_Process"
                tableData={groupData}
              />
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default observer(PCProcessCsvReport);
